
import { Component, Prop, Vue } from "vue-property-decorator"

@Component
export default class EmptyModel extends Vue {
  @Prop({ required: false }) readonly button!: string
  @Prop({ required: false, default: false }) readonly disabled!: boolean
  @Prop({ required: false, default: false }) readonly loading!: boolean
}
